<template>
  <div class="row m-0">
    <div class="col-md-6 event">
      <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-indicators">
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="John on Parade"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Capital"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="House Appropriations Committee"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="House Photo"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Biking with KT"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Lincoln"></button>
        </div>

        <div class="carousel-inner">
          <div class="carousel-item active">
            <img class="d-block w-100" src="../assets/John_and_Joe_Parade.jpg" alt="John on Parade">
          </div>
          <div class="carousel-item">
            <img class="d-block w-100" src="../assets/Photos/Capital.jpg" alt="Capital">
          </div>
          <div class="carousel-item">
            <img class="d-block w-100" src="../assets/Photos/HouseAppropriationsCommittee.jpg" alt="House Appropriations Committee">
          </div>
          <div class="carousel-item">
            <img class="d-block w-100" src="../assets/Photos/HousePhoto.jpg" alt="House Photo">
          </div>
          <div class="carousel-item">
            <img class="d-block w-100" src="../assets/Photos/JeepandKT.jpg" alt="Biking with KT">
          </div>
          <div class="carousel-item">
            <img class="d-block w-100" src="../assets/Photos/Lincoln.jpg" alt="Lincoln">
          </div>
        </div>

        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>

    <div class="col-md-6 text-md-left p-4">
      <h1 style="font-variant: small-caps">Additional Information</h1>
      <p>Working with fellow House and Senate members across party lines, State Agencies, and the current Administration, John has brought a strong and highly respected voice to the State House to help chart a better direction for Vermont to meet the needs of all Vermonters. As Representatives and Senators are preparing to return to the 2026 legislative session that begins on January 6th, there is much work to be continued and completed that includes Affordability, Education, Environment, Healthcare, Housing, Public Safety, and Workforce.</p>
      <p>Do not hesitate to reach out to your Representatives and Senators to share your thoughts and ideas that are solution-based to best address the work that is before the Legislature during this 2026 session.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdditInfo",

}
</script>

<style scoped>
.event{
  background-color: rgba(0,0,0,0.5);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.carousel-item {
  height: 600px;
  overflow: hidden;
}

.carousel-item img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

a {
  font-weight: bold;
  color: rgb(79, 121, 168);
}
</style>
